import { useFocusTrap as useMantineFocusTrap } from '@mantine/hooks';

export const useFocusTrap = useMantineFocusTrap;
